export default __webpack_public_path__ + "static/media/university.d43f9813.png";